export enum ServiceType {
    Recurring = 1,
    OneTime = 2,
}

export const ServiceTypeOptions = [
    { id: ServiceType.Recurring, label: "Recurring" },
    { id: ServiceType.OneTime, label: "OneTime" },
];

export enum ProjectFrom {
    Internal = 1,
    External = 2,
}

export const ProjectFromOptions = [
    { id: ProjectFrom.Internal, label: "Internal" },
    { id: ProjectFrom.External, label: "External" },
];

export interface IProjectService {
    id?: number;
    serviceId?: number;
    name?: string;
    serviceName?: string;
}

export interface IProject {
    id?: number;
    projectId?: number;
    leadId?: number;
    projectName?: string;
    companyName?: string;
    projectFrom?: ProjectFrom | number | null;
    ProjectFrom?: ProjectFrom | number | null;
    serviceInterestedIn?: (IProjectService | string)[] | string;
    serviceInterestedInIds?: number[];
    serviceType?: number | string | null;
    projectStartDate?: string | null;
    projecStartDate?: string | null;
    projectEndDate?: string | null;
    projectAmount?: number | null;
    projectEstimatedDuration?: number | string | null;
    projectDuration?: number | string | null;
    projectDurationType?: number;
    bdmName?: string | null;
    bdm?: string | null;
    preSalesName?: string | null;
    preSales?: string | null;
    sourceName?: string | null;
    sourceId?: number | null;
    projectWonDate?: string | null;
    wonDate?: string | null;
    projectStatus?: string | null;
    leadStatus?: string | null;
    status?: string | null;
    isAccepted?: boolean | null;
    projectDescription?: string | null;
    description?: string | null;
    [key: string]: any;
}

export interface IProjectTable {
    leads: IProject[];
    totalCount: number;
    statusCounts?: any[];
}

export interface IUpdateProjectDto {
    companyId?: number;
    CompanyId?: number;
    projectAmount?: number;
    projectDuration?: number;
    projectEstimatedDuration?: number;
    projectStartDate?: string;
    projecStartDate?: string;
    projectEndDate?: string;
    serviceType?: number;
    projectFrom?: ProjectFrom | number | null;
    ProjectFrom?: ProjectFrom | number | null;
    serviceInterestedInIds?: number[];
    serviceInterestedIn?: number[];
    projectDescription?: string;
    description?: string;
}
